import "./policy.css";

export default function Privacy() {

  return (
    <div className="policy-page">

      <div className="policy-hero">
        <h1>Privacy Policy</h1>
        <p>Your privacy and security matter to us.</p>
      </div>

      <div className="policy-container">

        <div className="policy-card">
          <h2>Information We Collect</h2>

          <p>
            We collect customer information such as name,
            email, shipping address, and phone number
            for order processing and customer support.
          </p>
        </div>

        <div className="policy-card">
          <h2>Payment Security</h2>

          <p>
            All payments are securely processed using
            trusted payment gateways. We never store
            sensitive card information.
          </p>
        </div>

        <div className="policy-card">
          <h2>Customer Privacy</h2>

          <p>
            Apple Smoke Shop never sells or shares
            your personal information with third parties.
          </p>
        </div>

      </div>

    </div>
  );
}